﻿import {
    ValgStateActionTypes,
    TOGGLE_AVSTAND,
    ToggleAvstandAction,
    TOGGLE_VILKAR,
    ToggleVilkarAction,
    ValgState,
    UPDATE_VALG,
} from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederBsAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';
import AAvstandValg from '../../Utilities/A-AvstandValg';
import BReisetidValg from '../../Utilities/B-ReisetidValg';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleAvstand(): ToggleAvstandAction {
    return {
        type: TOGGLE_AVSTAND,
    };
}

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

const getA = (state: ValgState): string | undefined => {
    return state.aAvstand?.value;
};

const getB = (state: ValgState): string | undefined => {
    return state.bReisetid?.value;
};

export const updateVisning = (): ThunkAction<void, VeilederBsAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederBsAppState, {}, AnyAction>, getState: () => VeilederBsAppState): void => {
        const currentState = getState();
        const visBoksB = visB(currentState);
        const visResultatKanFa = visRKanFa(currentState);
        const visResultatKanFaLangReisevei = visRKanFaLangReisevei(currentState);
        const visResultatKanKanskjeFa = visRKanKanskjeFa(currentState);

        dispatch(
            setVisning({
                visBoksB,
                visResultatKanFa,
                visResultatKanFaLangReisevei,
                visResultatKanKanskjeFa,
            }),
        );
    };
};

const visB = (state: VeilederBsAppState): boolean => {
    return getA(state.valg) === AAvstandValg.a2_mindreEnn40km;
};

const visRKanFa = (state: VeilederBsAppState): boolean => {
    return getA(state.valg) === AAvstandValg.a1_merEnn40km;
};

const visRKanFaLangReisevei = (state: VeilederBsAppState): boolean => {
    return getB(state.valg) === BReisetidValg.b1_merEnn40km;
};

const visRKanKanskjeFa = (state: VeilederBsAppState): boolean => {
    return getB(state.valg) === BReisetidValg.b2_mindreEnn40km;
};
